import React, { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import enGbLocale from "@fullcalendar/core/locales/en-gb";

interface HomePageDoctorCalenderProps {
  upcommingFromTodayAppointments: any[];
}

const HomePageDoctorCalender: React.FC<HomePageDoctorCalenderProps> = ({
  upcommingFromTodayAppointments,
}) => {
  const [events, setEvents] = useState<any[]>([]);
  const [doctorColor, setDoctorColor] = useState<string>("");

  
  const getRandomColor = () => {
    const hue = Math.floor(Math.random() * 360);
    return `hsl(${hue}, 70%, 50%)`;
  };
  const doctorName =
    upcommingFromTodayAppointments?.[0]?.doctorName || "Doctor";

  useEffect(() => {
    if (!upcommingFromTodayAppointments?.length) return;

    const color = doctorColor || getRandomColor();
    setDoctorColor(color);

    // ✅ Map API data to FullCalendar events
    const mappedEvents = upcommingFromTodayAppointments.map((appt: any) => ({
  title: `${appt.patientName}`,
  start: `${appt.appointmentDate}T${appt.slotStartTime}`,
  end: `${appt.appointmentDate}T${appt.slotEndTime}`, // optional if you have end time
  extendedProps: {
    doctorName: appt.doctorName,
    age: appt.age,
    gender: appt.gender,
    appointmentId: appt.appointmentId,
    slotStartTime: appt.slotStartTime,  
    slotEndTime: appt.slotEndTime,      
  },
  color,
  textColor: "#fff",
}));


    setEvents(mappedEvents);
  }, [upcommingFromTodayAppointments]);

  return (
    <div className="w-full py-5">
      <div className="px-5 shadow-lg rounded-xl bg-white py-5">
        {/* ✅ doctorName derived dynamically */}
        {/* <h3 className="text-lg font-semibold mb-3">{doctorName}'s Calendar</h3> */}

        <FullCalendar
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          initialView="timeGridWeek"
          initialDate={new Date()}
          nowIndicator={true}
          headerToolbar={{
            left: "prev,next today",
            center: "title",
            right: "dayGridMonth,timeGridWeek,timeGridDay",
          }}
          locale={enGbLocale}
          buttonText={{
            today: "📅 Today",
            month: "Month",
            week: "Week",
            day: "Day",
          }}
          slotLabelFormat={{
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          }}
          eventTimeFormat={{
            hour: "numeric",
            minute: "2-digit",
            meridiem: "short",
            hour12: true,
          }}
          events={events}
          slotMinTime="09:00:00"
          slotMaxTime="21:00:00"
            slotDuration="00:15:00"
          height="80vh"
       eventContent={(eventInfo) => {
            const { event, view } = eventInfo;
            const start = new Date(event.start!);
            const appointmentId = event.extendedProps.appointmentId;

            const formatTime = (date: Date) =>
              date.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              });

            const isMonthView = view.type === "dayGridMonth";

            return (
              <div className="flex items-center gap-1 leading-tight">
                {isMonthView ? (
                  <>
                    <span
                      className="inline-block w-2 h-2 rounded-full"
                      style={{
                        backgroundColor:
                          event.backgroundColor || event.borderColor,
                      }}
                    ></span>
                    <span className="text-[11px] font-semibold">
                      {formatTime(start)}
                    </span>
                    <span className="text-[11px]">{event.title}</span>
                  </>
                ) : (
                  <div className="flex flex-col leading-tight">
                    <span className="text-[11px] font-semibold">
                      {formatTime(start)} • #{appointmentId}
                    </span>
                    <span className="text-[11px]">{event.title}</span>
                  </div>
                )}
              </div>
            );
          }}
          eventClick={(info) => {
            const calendarApi = info.view.calendar;
            const eventStart = info.event.start;
            if (eventStart) {
              calendarApi.changeView("timeGridDay", eventStart);
            }
          }}



        />
         <style>{`

.fc .fc-toolbar.fc-header-toolbar {
font-size: 12px !important; 
}

/* shrink navigation buttons */
.fc .fc-toolbar button {
  font-size: 12px !important;
  padding: 0px 6px !important;
  height: 25px !important;
}

/* shrink title (date range like Aug 17 – 23, 2025) */
.fc .fc-toolbar-title {
  font-size: 12px !important;
  font-weight: 600 !important;
}

  .fc-button:hover {
  background: #e5e7eb;
          }
  
 .fc-event {
  border-radius: 6px;
  font-size: 12px;
  padding: 2px 4px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
  border: none;
  transition: all 0.2s ease;
  position: relative;
  z-index: 1;
  white-space: nowrap;   /* default: clipped text */
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;       /* don’t overflow by default */
}

/*  On hover, expand to show full name */
.fc-event:hover,
.fc-timegrid-event-harness:hover,
.fc-daygrid-event-harness:hover {
  cursor: pointer;
  z-index: 9999 !important; 
  white-space: normal;      
  overflow: visible;         
  max-width: none;          
  min-width: 100%;    
  transform: scale(1.02);    
}

    /*  Add right padding in MONTH view so dates don't hide behind scrollbar */
  .fc-dayGridMonth-view .fc-scroller {
    padding-right: 12px !important; 
    box-sizing: content-box;
  }

    /* Week & Day views: hide scrollbar but allow scrolling */
  .fc-timeGridWeek-view .fc-scroller,
  .fc-timeGridDay-view .fc-scroller {
    scrollbar-width: none;      /* Firefox */
    -ms-overflow-style: none;   /* IE/Edge */
  }

      .fc-dayGridMonth-view .fc-scroller::-webkit-scrollbar ,
  .fc-timeGridWeek-view .fc-scroller::-webkit-scrollbar,
  .fc-timeGridDay-view .fc-scroller::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }


        `}</style>
      </div>
    </div>
  );
};

export default HomePageDoctorCalender;
